export default "/assets/images/life-saving-co-sensor-thumbnail.8057c532e8fa8bca.jpg";